import React from 'react'

import Icon from 'app/app/(client)/components/atoms/Icon/Icon'
import Spinner from 'app/app/(client)/components/atoms/Spinner/Spinner'
import { useAppDispatch, useAppSelector } from 'app/app/(client)/hooks/redux-hook'
import { syncOpportunity } from 'app/app/(client)/redux/features/customers/data'
import { useNetwork } from 'app/app/(client)/hooks/useNetwork'

interface SalesforceSyncOppProps {
  opportunityId: string
}

const SalesforceSyncOpp: React.FC<SalesforceSyncOppProps> = ({ opportunityId }) => {
  const isOnline = useNetwork()
  const dispatch = useAppDispatch()
  const { data: syncStatus } = useAppSelector(state => state.currentSync)
  const SFSyncStatus = opportunityId && syncStatus ? syncStatus[opportunityId] : undefined

  const onUpdateOfferSalesforceData = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    if (isOnline) {
      dispatch(syncOpportunity(opportunityId))
    }
  }

  if (SFSyncStatus?.isSyncing) {
    return (
      <div>
        <Spinner id={`salesforce-sync-spinner-${opportunityId}`} type={'primary'} size={19} speed={1} />
      </div>
    )
  }
  if (SFSyncStatus && !SFSyncStatus.syncedWithSF) {
    return (
      <div id={`salesforce-refresh-${opportunityId}`} onClick={onUpdateOfferSalesforceData}>
        <Icon name="icon-refresh" className="text-18px " />
      </div>
    )
  }

  return <Icon name="icon-chevron-right" className="text-24px" />
}

export default SalesforceSyncOpp
